import React from 'react';
import styled from 'styled-components';
import colors from '../utils/colors';
import fonts from '../utils/fonts';

const Antetituloh4 = styled.h4`
  font-family: ${fonts.sans};
  margin: 0 auto;
  padding: 0 0 0.4em 0;
  color: ${colors.main};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-size: 0.9em;
  &:before {
    margin-bottom: 10px;
    display: block;
    content: '';
    width: 40px;
    height: 5px;
    background: ${colors.black};
  }
  @media (max-width: 768px) {
    &:before {
      display: none;
    }
  }
`;

const Antetitulo = ({ contenido }) => (
  <div>
    <Antetituloh4>{contenido}</Antetituloh4>
  </div>
);

export default Antetitulo;



// WEBPACK FOOTER //
// ./src/components/Antetitulo.js